import getColorPalettes from './color-palettes';

const getColorPalette = (state, colorPaletteId) => {
  const colorPalettes = getColorPalettes(state);

  return colorPalettes.find((colorPalette) => colorPalette.id === colorPaletteId) || null;
};

export default getColorPalette;
